import React, { useState } from 'react';
import { WEBApi } from '../API/WEBApi';
import RichTextEditor from '../../components/RichTextEditor/RichTextEditor';
import ImageSelector from '../Components/ImageSelector';

const CreateRecognition: React.FC = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [image, setImage] = useState('');
  const [date, setDate] = useState('');
  const [url, setUrl] = useState('');
  const [published, setPublished] = useState(false);
  const [showURL, setShowURL] = useState(false);

  
  const [orderNo, setOrderNo] = useState<number>(0); // <-- Added

  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    setError(null);

    try {
      await WEBApi.createRecognition({
        title,
        content,
        image: image || undefined,
        date,
        published,
        url,
        showURL,
        orderNo,
      });

      setMessage('Recognition created successfully!');
      setTitle('');
      setContent('');
      setImage('');
      setDate('');
      setUrl('');
      setShowURL(false);
      setPublished(false);
      setOrderNo(0); // <-- Reset field
    } catch (err) {
      setError('Failed to create recognition. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <h3>Create New Recognition</h3>
      {message && <div className="alert alert-success">{message}</div>}
      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        {/* Title */}
        <div className="mb-3">
          <label htmlFor="title" className="form-label">Title</label>
          <input
            type="text"
            id="title"
            className="form-control"
            value={title}
            onChange={e => setTitle(e.target.value)}
            required
            disabled={loading}
          />
        </div>

        {/* Content */}
        <div className="mb-3">
          <label htmlFor="content" className="form-label">Content</label>
          <RichTextEditor value={content} onChange={setContent} />
        </div>

        {/* Image */}
        <div className="mb-3">
          <label className="form-label">Select Image</label>
          <ImageSelector
            selectedUrl={image}
            onSelect={(url) => setImage(url)}
          />
        </div>

        {/* Date */}
        <div className="mb-3">
          <label htmlFor="date" className="form-label">Date</label>
          <input
            type="text"
            id="date"
            className="form-control"
            value={date}
            onChange={e => setDate(e.target.value)}
            disabled={loading}
          />
        </div>

        {/* URL */}
        <div className="mb-3">
          <label htmlFor="url" className="form-label">URL</label>
          <input
            type="text"
            id="url"
            className="form-control"
            value={url}
            onChange={e => setUrl(e.target.value)}
            disabled={loading}
            placeholder="https://your-article-link.com"
          />
        </div>

         {/* showURL */}
         <div className="form-check mb-3">
          <input
            type="checkbox"
            id="showURL"
            className="form-check-input"
            checked={showURL}
            onChange={e => setShowURL(e.target.checked)}
            disabled={loading}
          />
          <label htmlFor="showURL" className="form-check-label">ShowURL</label>
        </div>

        {/* Order No */}
        <div className="mb-3">
          <label htmlFor="orderNo" className="form-label">Order Number</label>
          <input
            type="number"
            id="orderNo"
            className="form-control"
            value={orderNo}
            onChange={e => setOrderNo(parseInt(e.target.value, 10) || 0)}
            min={0}
            disabled={loading}
          />
        </div>

        {/* Published */}
        <div className="form-check mb-3">
          <input
            type="checkbox"
            id="published"
            className="form-check-input"
            checked={published}
            onChange={e => setPublished(e.target.checked)}
            disabled={loading}
          />
          <label htmlFor="published" className="form-check-label">Published</label>
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Creating...' : 'Create Recognition'}
        </button>
      </form>
    </div>
  );
};

export default CreateRecognition;
